import React from 'react';
import { useSelector } from 'react-redux';
import { selectAddCompanyPopup } from 'Selector/CompaniesSelector';
import ProfilePopups from './ProfilePopups';

const AddCompanyLimitPopup = function AddCompanyLimitPopup() {
  const addCompanyPopup = useSelector(selectAddCompanyPopup);
  return (
    addCompanyPopup.showPlanPopup > 0 ? (
      <ProfilePopups
        isAddCompany
        title={addCompanyPopup?.popupHeading}
        description={addCompanyPopup?.popupText}
        type={addCompanyPopup?.showPlanPopup}
        callToAction={addCompanyPopup?.callToAction}
        contactUs={addCompanyPopup?.contactUsEmail}
        isDownloadPopup={false}
        loading={false}
      />
    ) : null
  );
};

export default AddCompanyLimitPopup;
